import React from 'react'
import Button from '@/components/Button'
import Title from '@/components/Title'
import { useModal } from '@/hooks'
import style from './styles/upload.module.scss'

const WorkUploaded = (): React.ReactElement => {
  const { modalProps } = useModal()

  return (
    <div>
      <Title type='h2' theme='h3' className={style.upload__title}>
        Твоя работа загружена!
      </Title>

      <p className={style.upload__text}>
        Работа будет проверена в ближайшее время и добавлена в список работ
        конкурса.
      </p>

      <p className={style.upload__text}>Удачи!</p>

      <Button
        href={modalProps.url ?? '/'}
        size='large'
        wide
        highlight
        theme='secondary'
      >
        К конкурсу
      </Button>
    </div>
  )
}

export default WorkUploaded
